import { SALE, DEVELOPMENT } from '@/utils/constants/filters'
import developmentTypeMixin from '@/mixins/development-type'
import ozIconRemoveFilter from '../../oz-icon-remove-filter'

export default {
  name: 'oz-development-type',

  props: {
    isPill: { type: Boolean, default: false },
    selectedConstruction: { type: String },
  },

  mixins: [developmentTypeMixin],

  created () {
    const developmentTypesMap = this.$_set_development_type()
    this.developmentType = developmentTypesMap
    this.$_set_selected_construction(developmentTypesMap)
  },

  watch: {
    selectedConstruction () {
      this.$_set_selected_construction(this.developmentType)
    },
  },

  computed: {
    pillSelectedConstruction () {
      if (!this.selectedConstruction) {
        this.values = []
        return []
      }

      const split = this.selectedConstruction.split(',')
      const newArray = []

      split.forEach((el) => {
        const constructionStatus = this.developmentType.get(el)
        newArray.push(constructionStatus)
      })

      return newArray
    },
  },

  methods: {

    removeFilter (constructionStatus) {
      const currentConstruction = this.values.filter(
        (development) => development !== constructionStatus,
      )

      if (!currentConstruction.length) {
        this.$_no_one_construction_selected()
        return
      }

      const defaultConstruction = {
        business: SALE,
        listingType: DEVELOPMENT,
        constructionStatus: currentConstruction.toString(),
      }
      this.$_filters_update(defaultConstruction)
    },

  },

  components: {
    ozIconRemoveFilter,
  },

}
